import type { GuideField } from '../types';

interface NumberFieldProps {
  field: GuideField;
  value: string;
  onChange: (value: string) => void;
  isText?: boolean;
}

export const NumberField = (props: NumberFieldProps) => {
  const { field, value, onChange, isText = false } = props;

  return (
    <label className="block text-sm font-semibold text-secondary-950">
      {field.label}
      <input
        type={isText ? 'text' : 'number'}
        inputMode={isText ? undefined : 'decimal'}
        min={isText ? undefined : 0}
        value={value}
        placeholder={field.placeholder}
        onChange={(event) => onChange(event.target.value)}
        className="mt-1 w-full rounded-md border border-secondary-200 bg-white px-3 py-2 text-sm font-normal text-secondary-950 placeholder:text-secondary-400"
      />
    </label>
  );
};
